import { ServiceRequestBase } from "../ServiceRequestBase";

export class LoginRequest extends ServiceRequestBase
{
  public Username: string | null = null;
  public Password: string | null = null;
}
